import { Routes, Route } from "react-router-dom";

import { FoxgloveIntegration } from "./FoxgloveIntegration";

export function IntegrationsRoutes() {
  return (
    <Routes>
      <Route path="foxglove" element={<FoxgloveIntegration />} />
    </Routes>
  );
}
